import { render } from "./FillInfoAndCreateOrderView.vue?vue&type=template&id=a446784e&scoped=true"
import script from "./FillInfoAndCreateOrderView.vue?vue&type=script&lang=js"
export * from "./FillInfoAndCreateOrderView.vue?vue&type=script&lang=js"

import "./FillInfoAndCreateOrderView.vue?vue&type=style&index=0&id=a446784e&lang=scss&scoped=true"

import exportComponent from "/root/workspace/bjyx-h5_Pbc0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a446784e"]])

export default __exports__